import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";
import { Calendar, Clock, FileText, Wrench } from "lucide-react";
import React from "react";

export const AlertSummaryCards: React.FC<{ data: any }> = ({ data }) => {
  const summaryData = {
    emergencyWorkOrders: {
      count: data?.alertKpiCards?.emergencyWorkOrders?.count,
      description: "Require immediate attention",
    },
    slaBreaches: {
      count: data?.alertKpiCards?.slaBreaches?.count,
      description: "Service level violations",
    },
    overdueTasks: {
      count: data?.alertKpiCards?.overdueTasks?.count,
      description: "Past due date",
    },
    workOrderBacklog: {
      count: data?.alertKpiCards?.workOrderBacklog?.count,
      description: `Est. ${data?.alertKpiCards?.workOrderBacklog?.count} hours`,
    },
  };

  const statsData = [
    {
      title: "Emergency Service Orders",
      count: summaryData.emergencyWorkOrders.count,
      trendSummary: summaryData.emergencyWorkOrders.description,
      icon: <Wrench className="h-8 w-8 text-red-500" />,
      tooltip:
        "The number of open work orders that require immediate attention to prevent or resolve a critical failure.",
    },
    {
      title: "SLA Breaches",
      count: summaryData.slaBreaches.count,
      trendSummary: summaryData.slaBreaches.description,
      icon: <Clock className="h-8 w-8 text-yellow-500" />,
      tooltip:
        "The number of times this system has operated outside of its defined service level targets in the current period.",
    },
    {
      title: "Overdue Service Orders",
      count: summaryData.overdueTasks.count,
      trendSummary: summaryData.overdueTasks.description,
      icon: <FileText className="h-8 w-8 text-blue-500" />,
      tooltip:
        "The number of scheduled work orders for this system that have not been completed by their due date.",
    },
    {
      title: "Service Order Backlog",
      count: summaryData.workOrderBacklog.count,
      trendSummary: summaryData.workOrderBacklog.description,
      icon: <Calendar className="h-8 w-8 text-purple-500" />,
      tooltip:
        "The total estimated labor hours required to complete all currently open work orders for this system.",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {statsData.map((stat, index) => (
        <QuickStatsCard
          key={index}
          title={stat.title}
          count={stat.count}
          trendSummary={stat.trendSummary}
          icon={stat.icon}
          tooltip={stat.tooltip}
        />
      ))}
    </div>
  );
};
